module.exports = __webpack_public_path__ + "static/img/08.77a3e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/08.jpg
// module id = D8rg
// module chunks = 0